export const ATTRIBUTE_GROUP_KEY = ':@';
export const ATTRIBUTE_TEXT = '#text';
export const ATTRIBUTE_COMMENT = '#comment';
export const ATTRIBUTE_CDATA = '#cdata';
export const DECLARATION_TAG = 'DECLARATION_TAG';
export const TAG = 'TAG';

export const defaultTheme = {
  tagColor: '#d43900',
  textColor: '#333',
  attributeKeyColor: '#2a7ab0',
  attributeValueColor: '#008000',
  separatorColor: '#333',
  commentColor: '#aaa',
  cdataColor: '#1d781d',
  fontFamily: 'monospace',
};
